import { MutationTree } from 'vuex';
import { LangStoreType } from '@/types/store/lang-store.type';

export const mutations: MutationTree<LangStoreType> = {
  SET_CURRENT_LANG(state, newValue) {
    state.lang = newValue;
  },
};
